export default __webpack_public_path__ + "static/chemistry_bay-min-236876e9b0df0c71570cce75fdf31d6b.png";